enum LandContractType {
    OilAndGas = 1,
    SurfaceWaiver,
    SolarLease,
    BatteryStorage,
    BrineLease,
    RightOfWay,
    CarbonCapture
}

export default LandContractType;


// WEBPACK FOOTER //
// ./src/models/LandContractType.ts